import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
// Styles
import { MuiThemeProvider } from "@material-ui/core/styles";
import { getMuiTheme } from "./customTableStyle";
// Service
import useResources from "../../services/listing.service";
// Loader
import { ListWrapper } from "../../shared/listWrapper";
import BreadCrumb from "../../shared/BreadCrumb";
import Filter from "../Filter/Filter";
import { CustomRowRender, ListOptions } from "./Contants/Options";
import CustomeSettings from "./customSettings/customSettings";
import { SearchWidget } from "../../widgets/SearchWidget/SearchWidget";
import CustomPrintButton from "./CustomPrintButton/customPrintButton";
import { Grid } from "@material-ui/core";
import Loader from "shared/loader";
import WarningsModal from "shared/Modal/WarningsModal/WarningsModal";
import { getWarnings } from "services/claims.service";
import DropDownSearchMix from "components/Mix/DropDownSearchMix";

export default function List({
  url,
  columns,
  pagination = true,
  sort = true,
  defaultSort = "policyNo",
  defaultSortType = "DESC",
  defaultIndex = "policyNo",
  defaultPageNumber = 0,
  defaultPageSize = 10,
  defaultSearchColumn = "",
  defaultSearchValue = "",
  match,
  filterList = [],
  defaultSelected = "All",
  renderType = "List",
  reRender,
  filterType,
  searchArray,
  footerUpdate,
  footerType,
  type = "List",
  history,
  isSearch,
  options,
  actionRef,
  rowsPerPageOptions = [10, 20, 50],
  isDrop = false,
  dropDownData,
  isClick=false
}) {
  const [page, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortColumn, setSortColumn] = useState(defaultSort);
  const [sortColumnOrder, setSortColumnOrder] = useState(defaultSortType);
  const [searchValue, setSearchValue] = useState(defaultSearchValue);
  const [searchColumn, setSearchColumn] = useState(defaultSearchColumn);
  const [filterListUpdate, setfilterListUpdate] = useState(filterList);
  const [searchArrayUpdate, setSearchArrayUpdate] = useState(searchArray);
  const [searchText, setSearchText] = useState("");
  const [searchReRender, setSearchReRender] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(0);
  const [dropDownChange, setDropDownChange] = useState(null);
  const [data, count, isLoading] = useResources(
    url,
    page,
    pageSize,
    sortColumn,
    sortColumnOrder,
    type === "search" ? defaultSearchColumn : searchColumn,
    type === "search" ? defaultSearchValue : searchValue,
    filterListUpdate,
    reRender,
    filterType,
    searchArrayUpdate,
    footerType,
    isSearch,
    searchReRender,
  );
  useEffect(() => {
    if (defaultSearchValue) {
      setPageNumber(0);
    }
  }, [defaultSearchValue, reRender]);
  const handleFilterClick = (filterClick) => {
    if(isClick){
      return true;
    }
    setSearchValue(filterClick.filterValue);
    setSearchColumn(filterClick.filterByCol);
    setPageNumber(0);
    if (filterType === "diary") {
      if (searchArrayUpdate[2]["criteriaName"] === "isCleared") {
        searchArrayUpdate[2]["value"] = filterClick.filterValue;
      }
    } else if (filterType === "USERLIST") {
      let payload = searchArrayUpdate;
      if (searchText === "") {
        let newLoad = [
          {
            criteriaName: "isActive",
            value: filterClick.filterValue,
          },
        ];
        setSearchArrayUpdate(newLoad);
      } else {
        if (payload.length === 1) {
          payload.push({
            criteriaName: "isActive",
            value: filterClick.filterValue,
          });
        } else {
          payload[1]["criteriaName"] = "isActive";
          payload[1]["value"] = filterClick.filterValue;
        }
        setSearchArrayUpdate(payload);
      }
    }
  };

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changePage":
        setPageNumber(tableState.page);
        break;
      case "changeRowsPerPage":
        setPageSize(tableState.rowsPerPage);
        setPageNumber(0);
        break;
      default:
        break;
    }
  };
  const handleOnColumnSortChange = (changedColumn, direction) => {
    const order = direction === "desc" ? "DESC" : "ASC";
    setSortColumnOrder(order);
    setSortColumn(changedColumn);
  };

  const handleSearchUser = (e) => {
    e.persist();
    const { value } = e.target;
    setSearchText(value.trim(""));
  };

  const handleClear = () => {
    setSearchText("");
    setSearchColumn("userId");
    let payload = [
      {
        criteriaName: "isActive",
        value: searchValue,
      },
    ];
    setSearchArrayUpdate(payload);
  };

  const handleEnter = (e) => {
    e.preventDefault();
    let payload = searchArrayUpdate;
    if (searchText === " ") {
      let newdto = [
        {
          criteriaName: "isActive",
          value: searchValue,
        },
      ];
      // setSearchColumn("userId");
      setSearchReRender(!searchReRender);
      setPageNumber(0);
      setSearchArrayUpdate(newdto);
    } else {
      if (payload.length === 1) {
        payload.push({
          criteriaName: "isActive",
          value: searchValue,
        });
        payload[0]["criteriaName"] = "userId";
        payload[0]["value"] = searchText;
        // setSearchColumn("userId");
        setSearchArrayUpdate(payload);
        setSearchReRender(!searchReRender);
      } else {
        payload[0]["criteriaName"] = "userId";
        payload[0]["value"] = searchText;
        // setSearchColumn("userId");
        setSearchArrayUpdate(payload);
        setSearchReRender(!searchReRender);
      }
      setPageNumber(0);
    }
  };
  const [tempdata, setTempData] = useState({});
  const handleWarnings = (claimsDetails, claimNo) => {
    getWarnings(claimNo)
      .then((data) => {
        const { response, statusCode } = data.data;
        if (statusCode === 200) {
          if (response.length) {
            setWarnings(response);
            // setIsLoader(false);
            setOpenWarningModal(true);
            setTempData({
              claimNo: claimNo,
              policyNo: claimsDetails.policyNo,
            });
            setEnd(1);
          } else {
            window.open(
              "/#/app/claims-view/" + claimNo + "/" + claimsDetails.policyNo,
              "_blank",
            );
          }
        }
      })
      .catch(() => {});
  };
  const handleSubmit = () => {
    if (warnings.length === end) {
      setOpenWarningModal(false);
      setStart(0);
      setEnd(0);
      window.open(
        "/#/app/claims-view/" + tempdata.claimNo + "/" + tempdata.policyNo,
        "_blank",
      );
    } else {
      setStart(start + 1);
      setEnd(end + 1);
    }
  };

  const handleSearchEnter = (e) => {
    e.preventDefault();
    if (searchText.length > 0) {
      const dropDownVal = !dropDownChange
        ? searchArray[0].criteriaName
        : dropDownChange;
      setSearchValue(searchText.trim(""));
      setSearchColumn(dropDownVal);
    }
  };


  const clearSearch = () => {
    setSearchText("");
    setSearchValue("");
  };

  const setSearched = (e) => {
    e.persist();
    const { value } = e.target;
    setSearchText(value);
  };

  const onDropDownChange = (value) => {
    setDropDownChange(value);
    setSearchText("");
    setSearchValue("");
  };
  return (
    <>
      {match !== undefined || filterListUpdate.length > 0 ? (
        <div className={"rowConatiner"}>
          <div>
            {match !== undefined ? <BreadCrumb breadcrumb={match.url} /> : null}
          </div>
          {isSearch && isDrop ? (
            <DropDownSearchMix
              handleSearchEnter={handleSearchEnter}
              handleAgentSearch={setSearched}
              searchText={searchText}
              clearSearch={clearSearch}
              onDropDownChange={onDropDownChange}
              dropDownData={dropDownData}
              dropDownChange={dropDownChange}
            />
          ) : isSearch ? (
            <div className="search-user">
              <SearchWidget
                onChange={handleSearchUser}
                onClear={handleClear}
                onEnter={handleEnter}
                value={searchText}
                placeholder={"Search by User Id"}
              />
            </div>
          ) : null}
          <div>
            {filterListUpdate !== undefined && filterListUpdate.length ? (
              <Filter
                filterList={filterListUpdate || []}
                handleFilterClick={handleFilterClick}
                defaultSelected={defaultSelected}
              />
            ) : null}
          </div>
        </div>
      ) : null}
      <MuiThemeProvider theme={getMuiTheme(renderType)}>
        <MUIDataTable
          className="mui-table-list"
          data={data.map((item) => {
            return ListWrapper(item, columns);
          })}
          columns={columns}
          options={
            renderType === "List"
              ? Object.assign(
                  {},
                  ListOptions(
                    defaultIndex,
                    pagination,
                    isLoading,
                    sort,
                    count,
                    page,
                    handleOnColumnSortChange,
                    handleTableChange,
                    rowsPerPageOptions,
                  ),
                  options,
                ) ||
                ListOptions(
                  defaultIndex,
                  pagination,
                  isLoading,
                  sort,
                  count,
                  page,
                  handleOnColumnSortChange,
                  handleTableChange,
                  rowsPerPageOptions,
                )
              : CustomRowRender(
                  defaultIndex,
                  pagination,
                  isLoading,
                  sort,
                  count,
                  page,
                  handleOnColumnSortChange,
                  handleTableChange,
                  history,
                  defaultSearchValue,
                  defaultSearchColumn,
                  handleWarnings,
                )
          }
        />
      </MuiThemeProvider>
      {filterType === "diary" ? (
        <CustomeSettings
          page={page}
          pageSize={pageSize}
          sortColumn={sortColumn}
          sortColumnOrder={sortColumnOrder}
        />
      ) : null}
      {filterType === "claimFilter" ? (
        <Grid
          container
          style={{ backgroundColor: "#fff", padding: "10px", display: "none" }}
        >
          <Grid
            xs={12}
            item
            justify="center"
            alignItems="center"
            style={{ textAlign: "center" }}
          >
            <CustomPrintButton
              page={page}
              pageSize={10000}
              sortColumn={sortColumn}
              sortColumnOrder={sortColumnOrder}
              searchArrayUpdate={searchArrayUpdate}
              actionRef={actionRef}
            />
          </Grid>
        </Grid>
      ) : null}
      <WarningsModal
        warnings={warnings}
        openModal={openWarningModal}
        start={start}
        end={end}
        handleAction={handleSubmit}
      />
      <Loader open={isLoading} />
    </>
  );
}
